// import store from '../index'
// import gql from 'graphql-tag'

export const isLoggedIn = (state) => {
  return !!state.currentAccount
}

export const getAccountAddress = (state) => {
  if (!state.currentAccount.addresses?.[0]) {
    return {
      info: '',
      contactName: '',
      contactLastname: '',
      company: '',
      address: '',
      address2: '',
      city: '',
      country: 'Australia',
      state: '',
      postCode: '',
      phoneNumber: '',
      shippingNotes: ''
    }
  } else {
    const { __typename, ...addressWithoutTypename } = state.currentAccount.addresses?.[0]
    return addressWithoutTypename
  }
}

// export const currentAccountId = async (state) => {
//   return store.$apollo.query({
//     query: gql`
//       query  {
//         currentAccountId @client
//       }
//     `
//   })
// }
//
// export const currentAccount = async (state) => {
//   await store.$apollo.query({
//     query: gql`
//       query ($id: String!) {
//         account(id: $id) {
//           id,
//           email,
//           isAdmin,
//           activeCartId
//         }
//       }
//     `,
//     variables: {
//       id: await currentAccountId()
//     }
//   })
// }
